import { useCallback } from 'react';
import { FormResponseAnswers } from '../participation';
import { CustomSelectChoice } from '../form';
import { useAllOtherTranslations } from './useGetAnswerText';
import { useTranslation } from 'react-i18next';

export const useGetIndexedAnswerText = () => {
  const otherTranslations = useAllOtherTranslations();
  const { t } = useTranslation('common');
  return useCallback((formResponse: FormResponseAnswers) => {
    return formResponse.labels
      .map((label, index) => {
        const ref = formResponse.values[index];

        if (
          ref === CustomSelectChoice.Other &&
          !otherTranslations.has(label.trim().toLowerCase())
        ) {
          return `${t('screeningForm.other')} : ${label}`;
        }

        return label;
      })
      .join(', ');
  }, []);
};
